/* eslint-disable import/prefer-default-export */
import * as React from 'react'

import Login from '../pages/Login'
import Home from '../pages/Home'
import SolarPlantList from '../pages/SolarPlantList'
import Settings from '../pages/Settings'
import AddnewPlant from '../pages/AddNewPlant'
import AddMacID from '../pages/AddMacid'
import PlantTechnicalView from '../pages/PlantTechicalView'
import BusinessView from '../pages/PlantBusinessView'
import PlantMapView from '../pages/PlantMapView'
import SolarMapView from '../pages/SolarMapView'
import LogReport from '../pages/LogReport'
import UserList from '../pages/UserListing'
import InternalUserList from '../pages/InternalUserlist'
import MonthlyGeneration from '../pages/MonthlyGenerationDownload'
import IssueManagement from '../pages/IssueManagement'
import BillingRecords from '../pages/BillingRecords'
import DailyGenerationReport from '../pages/DailyGenerationReport'
import Homeimg from '../assets/images/home_3.svg'
import SolarPlant from '../assets/images/solar plant_3.svg'
import Settingsicon from '../assets/images/settings.svg'
import InvoiceBillDownload from '../pages/InvoiceBillDownload/InvoiceBillDownload'
import PlantReport from '../pages/PlantReport/PlantReport'
import NotificationView from '../pages/NotificationView/NotificationView'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AssignmentIcon from '@mui/icons-material/Assignment'
import AnalyticsIcon from '@mui/icons-material/Analytics';


export const ROUTES = {
  LOGIN: {
    path: '/',
    key: 'login',
    name: 'Login',
    exact: true,
    isSecured: false,
    hasMainNav: false,
    hasSideNav: false,
    listInSideNav: false,
    hasTopNav: false,
    UserType: true,
    Component: Login,
    params: {},
  },
  DASHBOARD: {
    path: '/dashboard',
    key: 'dashboard',
    name: 'Home Page',
    exact: true,
    redirectPath: '/dashboard',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: true,
    hasTopNav: true,
    UserType: false,
    Component: Home,
    sideNavIcon: <img src={Homeimg} alt="home icon" />,
    params: {},
  },
  SOLARPLANTLIST: {
    path: '/solarplantlist',
    key: 'solarplantlist',
    name: 'Solar Plant List',
    exact: true,
    redirectPath: '/solarplantlist',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: true,
    hasTopNav: true,
    UserType: true,
    Component: SolarPlantList,
    sideNavIcon: <img src={SolarPlant} alt="solarplant icon" />,
    params: {},
  },
  ADDNEWPLANT: {
    path: '/addnewplant',
    key: 'addnewplant',
    name: 'Add Plant',
    exact: true,
    redirectPath: '/addnewplant',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: false,
    hasTopNav: true,
    UserType: false,
    Component: AddnewPlant,
    sideNavIcon: <img src={SolarPlant} alt="add plant icon" />,
    params: {},
  },
  ISSUEMANAGEMENT: {
    path: '/issue-management',
    key: 'issuemanagement',
    name: 'Issue Management',
    exact: true,
    redirectPath: '/issue-management',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: true,
    hasTopNav: true,
    UserType: true,
    Component: IssueManagement,
    sideNavIcon: <AssignmentIcon sx={{color: '#5e68a3ff'}} />,
    params: {},
  },
  DAILYGENRATIONREPORT: {
    path: '/daily-generation-report',
    key: 'dailygenerationreport',
    name: 'DGR',
    exact: true,
    redirectPath: '/daily-generation-report',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: true,
    hasTopNav: true,
    UserType: true,
    Component: DailyGenerationReport,
    sideNavIcon: <AnalyticsIcon sx={{color: '#5e68a3ff'}} />,
    params: {},
  },
  BILLINGRECORDS: {
    path: '/billing-records',
    key: 'billingrecords',
    name: 'Billing Records',
    exact: true,
    redirectPath: '/billing-records',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: true,
    hasTopNav: true,
    UserType: true,
    Component: BillingRecords,
    sideNavIcon: <ReceiptLongIcon sx={{color: '#5e68a3ff'}} />,
    params: {},
  },
  REPORTS: {
    path: '/settings',
    key: 'settings',
    name: 'Settings',
    exact: true,
    redirectPath: '/settings',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: true,
    hasTopNav: true,
    UserType: true,
    Component: Settings,
    sideNavIcon: <img src={Settingsicon} alt="Settings icon" />,
    params: {},
  },
  ADDdeviceId: {
    path: '/Devicelist',
    key: 'Devicelist',
    name: 'Devicelist',
    exact: true,
    redirectPath: '/Devicelist',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: false,
    hasTopNav: true,
    UserType: false,
    Component: AddMacID,
    // sideNavIcon: <img src={Report} alt="report icon" />,
    params: {},
  },
  PLANTTECHNICALVIEW: {
    path: '/TechnicalView',
    key: 'TechnicalView',
    name: 'TechnicalView',
    exact: true,
    redirectPath: '/TechnicalView',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: false,
    hasTopNav: true,
    UserType: true,
    Component: PlantTechnicalView,
    // sideNavIcon: <img src={Report} alt="report icon" />,
    params: {},
  },
  BUSINESSVIEW: {
    path: '/BusinessView',
    key: 'BusinessView',
    name: 'BusinessView',
    exact: true,
    redirectPath: '/BusinessView',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: false,
    hasTopNav: true,
    UserType: false,
    Component: BusinessView,
    // sideNavIcon: <img src={Report} alt="report icon" />,
    params: {},
  },
  PLANTMAPVIEW: {
    path: '/PlantMapView',
    key: 'PlantMapView',
    name: 'PlantMapView',
    exact: true,
    redirectPath: '/PlantMapView',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: false,
    hasTopNav: true,
    UserType: true,
    Component: PlantMapView,
    // sideNavIcon: <img src={Report} alt="report icon" />,
    params: {},
  },
  SOLARMAPVIEW: {
    path: '/SolarMapView',
    key: 'SolarMapView',
    name: 'SolarMapView',
    exact: true,
    redirectPath: '/SolarMapView',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: false,
    hasTopNav: true,
    UserType: false,
    Component: SolarMapView,
    // sideNavIcon: <img src={Report} alt="report icon" />,
    params: {},
  },
  LOGREPORT: {
    path: '/LogReport',
    key: 'LogReport',
    name: 'LogReport',
    exact: true,
    redirectPath: '/LogReport',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: false,
    hasTopNav: true,
    UserType: false,
    Component: LogReport,
    // sideNavIcon: <img src={Report} alt="report icon" />,
    params: {},
  },
  USERLIST: {
    path: '/userlist',
    key: 'Userlist',
    name: 'Userlist',
    exact: true,
    redirectPath: '/userlist',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: false,
    hasTopNav: true,
    UserType: false,
    Component: UserList,
    // sideNavIcon: <img src={Report} alt="report icon" />,
    params: {},
  },
  INTERNALUSERLIST: {
    path: '/internaluserlist',
    key: 'Internaluserlist',
    name: 'Internaluserlist',
    exact: true,
    redirectPath: '/internaluserlist',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: false,
    hasTopNav: true,
    UserType: false,
    Component: InternalUserList,
    // sideNavIcon: <img src={Report} alt="report icon" />,
    params: {},
  },
  MONTHLYGENERATION: {
    path: '/monthlygeneration',
    key: 'Monthlygeneration',
    name: 'Monthlygeneration',
    exact: true,
    redirectPath: '/monthlygeneration',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: false,
    hasTopNav: true,
    UserType: false,
    Component: MonthlyGeneration,
    // sideNavIcon: <img src={Report} alt="report icon" />,
    params: {},
  },
  INVOICEBILL: {
    path: '/invoice',
    key: 'Invoice',
    name: 'Invoice',
    exact: true,
    redirectPath: '/invoice',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: false,
    hasTopNav: true,
    UserType: false,
    Component: InvoiceBillDownload,
    // sideNavIcon: <img src={Report} alt="report icon" />,
    params: {},
  },
  PLANTREPORT: {
    path: '/plantreport',
    key: 'Plantreport',
    name: 'Plantreport',
    exact: true,
    redirectPath: '/plantreport',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: false,
    hasTopNav: true,
    UserType: false,
    Component: PlantReport,
    // sideNavIcon: <img src={Report} alt="report icon" />,
    params: {},
  },
  NOTIFICATIONVIEW: {
    path: '/NotificationView',
    key: 'NotificationView',
    name: 'NotificationView',
    exact: true,
    redirectPath: '/NotificationView',
    isSecured: true,
    hasMainNav: true,
    hasSideNav: true,
    listInSideNav: false,
    hasTopNav: true,
    UserType: false,
    Component: NotificationView,
    // sideNavIcon: <img src={Report} alt="report icon" />,
    params: {},
  },
}
